import { useAuthStore } from '../stores/authStore'

export function getReturnToUrl() {
  // Cleaning any leading or trailing slashes from the basename
  const basename = useAuthStore.getState().basename?.replace(/^\/|\/$/g, '')
  const currentUrl = window.location.pathname.includes('/auth/redirect')
    ? '/'
    : `${window.location.pathname}${window.location.search}`

  // Removes the basename from the redirect target
  return currentUrl.replace(new RegExp(`^/${basename}/?`), '/')
}
